import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const LinkComponent = ({
  ariaLabel, children, href, variant, ...rest
}) => (
  <a
    className={classnames('nmx-link', `nmx-link--${variant}`, (variant === 'secondary' && 'nmx-link--stand-alone'))}
    href={href}
    {...rest}>
    {children}
  </a>
);

LinkComponent.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  id: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
};

LinkComponent.defaultProps = {
  children: '',
  variant: 'primary',
};

export default LinkComponent;
